import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Kiacarencecabserviceinmumbai() {



const cardData = {
  keyword: " Kia Carens Cab Service in Mumbai",

headingDescription:
  "Omshree Cab offers reliable and comfortable Kia Carens cab service in Mumbai for travelers who want a spacious, stylish, and fuel‑efficient ride for city travel, airport transfers, family outings, corporate travel, or outstation trips. The Kia Carens is a versatile multi‑purpose vehicle (MPV) known for its roomy interiors, flexible seating configurations, smooth performance, and modern features, making it ideal for families, groups, and long‑distance journeys. With Omshree Cab’s flexible booking options including one‑way rides, round trips, hourly packages, and full‑day rentals, you can enjoy transparent pricing and professional service at every step. Each Kia Carens in our fleet is air‑conditioned, well‑maintained, and driven by experienced chauffeurs familiar with Mumbai’s traffic patterns and popular routes. With easy online booking, punctual pickups from any location in Mumbai (including airports, railway stations, hotels, and residences), and 24/7 customer support, Kia Carens cab service in Mumbai becomes a smooth and worry‑free experience.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India is one of Mumbai’s most iconic landmarks located on the waterfront in South Mumbai. Built during the British era, the grand arch monument attracts tourists for photography, sightseeing, and ferry rides to Elephanta Island. The surrounding Colaba area features vibrant cafes, street markets, and heritage buildings. Choosing a Kia Carens cab ensures a spacious and comfortable ride for families or groups to visit this famous destination without worrying about city traffic or parking."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a scenic coastal road along the Arabian Sea, popularly called the Queen’s Necklace because of the string of lights that sparkle at night. Visitors enjoy leisurely walks, sunset views, and the cool sea breeze along this iconic boulevard. The route connects several attractions in South Mumbai and provides a refreshing city drive. A Kia Carens cab delivers a smooth and roomy ride for sightseeing and comfort while exploring Marine Drive and nearby attractions."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of Mumbai’s most popular beaches known for its sandy shores, seaside vibe, and delicious street food like pav bhaji, bhel puri, and pani puri. Families, groups, and tourists visit the beach to relax, catch the sunset, and enjoy the lively atmosphere. A Kia Carens cab offers ample seating and legroom, making it perfect for comfortable travel to and from Juhu Beach with family or friends."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is a renowned Hindu temple dedicated to Lord Ganesha and attracts devotees from all over the country. The temple’s serene environment and architecture make it a major spiritual destination. During festivals like Ganesh Chaturthi, it experiences heavy footfall. Booking a Kia Carens cab makes traveling to this sacred site convenient and comfortable for families, groups, and pilgrims without worrying about parking or crowded local transport."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "Bandra Worli Sea Link is an architectural marvel connecting Bandra and Worli across the Arabian Sea. The bridge offers breathtaking views of the sea and city skyline, especially during sunset or night when lights illuminate the bridge. Many visitors enjoy driving across the Sea Link for the scenic beauty and urban experience. A Kia Carens cab ensures a relaxed and enjoyable ride across this landmark, ideal for group or family outings."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a famous Islamic shrine located on a small island off the coast of Mumbai, connected to the mainland by a narrow pathway visible during low tide. The shrine attracts devotees and tourists who come to offer prayers and enjoy the peaceful surroundings along with sea views. A Kia Carens cab provides a comfortable and convenient transfer to this spiritual destination, especially for group travel or family visits."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock‑cut caves on Elephanta Island known for intricate stone carvings dedicated to Lord Shiva. Recognized as a UNESCO World Heritage Site, the caves attract tourists interested in history, culture, and architecture. Visitors typically take a ferry from the Gateway of India to reach the island. Booking a Kia Carens cab allows for hassle‑free transport to the ferry terminal, ensuring a smooth start to the journey for families or travel groups."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a large urban forest reserve within Mumbai offering trekking, nature walks, wildlife spotting, and the ancient Kanheri Caves. Nature lovers and families spend time exploring lush greenery and scenic trails. A Kia Carens cab provides a comfortable and spacious ride for a full‑day trip to this natural attraction, making it ideal for group travel with friends or family."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a bustling shopping street in South Mumbai known for its vibrant markets, fashion stalls, handicrafts, and street food. Visitors enjoy browsing through various products and savoring local cuisine at nearby cafes. A Kia Carens cab ensures a roomy and comfortable journey for explorers heading to this lively marketplace and beyond."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also known as Pherozeshah Mehta Gardens, are landscaped terraces on Malabar Hill offering panoramic views of Marine Drive and the Arabian Sea. Visitors come here for peaceful walks, photography, and relaxation amidst greenery. A Kia Carens cab makes it easy to reach this scenic location with family or groups, providing comfortable transport and flexibility in planning your Mumbai sightseeing itinerary."
  }
],



services: [
{
name: "Kia Carens Cab Service Mumbai",
description: "Kia Carens cab service in Mumbai provides comfortable and premium transportation for passengers traveling within the city and to nearby destinations. The Kia Carens is a modern MPV known for its spacious seating, stylish interiors, and smooth driving experience. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for family travel, airport transfers, and business trips. Air-conditioned interiors ensure relaxed journeys for passengers. Flexible booking options allow convenient ride reservations anytime."
},
{
name: "Kia Carens on Rent Mumbai",
description: "Kia Carens on rent in Mumbai offers spacious and comfortable MPV transportation for passengers traveling with family or groups. The vehicle provides comfortable seating, smooth suspension, and modern interiors suitable for city and highway travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for family tours, corporate travel, and weekend trips. Spacious interiors ensure comfortable journeys for passengers. Flexible rental options allow easy reservations anytime."
},
{
name: "Kia Carens Taxi Mumbai",
description: "Kia Carens taxi in Mumbai offers stylish and comfortable transportation for passengers seeking modern MPV travel. The vehicle provides smooth driving performance and spacious seating for multiple passengers. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for airport transfers, family travel, and corporate rides. Air-conditioned interiors ensure comfortable journeys. Easy taxi booking options allow quick reservations."
},
{
name: "Kia Carens Rental Mumbai",
description: "Kia Carens rental in Mumbai provides reliable and comfortable transportation for passengers looking for spacious MPV travel. The vehicle offers modern features, comfortable seating, and smooth highway performance suitable for long journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, and transport hubs. Ideal for family trips, business travel, and sightseeing tours. Comfortable interiors ensure relaxed journeys for passengers. Flexible rental options allow convenient travel planning."
},
{
name: "Kia Carens Airport Cab Mumbai",
description: "Kia Carens airport cab in Mumbai provides convenient airport transportation with spacious seating and luggage capacity. The vehicle ensures smooth travel between airport terminals and city destinations. Professional drivers monitor flight schedules to ensure punctual pickup and drop services. Pickup services are available from homes, offices, hotels, and airport terminals across Mumbai. Ideal for business travelers, tourists, and family airport transfers. Air-conditioned interiors ensure comfortable journeys with luggage. Flexible booking options allow advance reservations."
},
{
name: "Kia Carens Outstation Cab Mumbai",
description: "Kia Carens outstation cab in Mumbai offers comfortable long-distance travel for passengers planning trips outside the city. The vehicle provides smooth highway performance and spacious seating ideal for extended journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, and railway stations. Ideal for weekend trips, pilgrimage tours, and family vacations. Spacious luggage area ensures convenient travel. Flexible one-way and round-trip booking options allow easy travel planning."
},
{
name: "Kia Carens One Way Cab Mumbai",
description: "Kia Carens one way cab in Mumbai offers economical intercity transportation without return charges. The vehicle provides comfortable seating and smooth travel suitable for long highway journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, and airport terminals. Ideal for airport transfers, business travel, and tourism visits. Air-conditioned interiors ensure relaxed journeys for passengers. Flexible booking options allow quick ride reservations."
},
{
name: "Kia Carens Family Cab Mumbai",
description: "Kia Carens family cab in Mumbai provides spacious transportation ideal for families traveling together. The vehicle offers comfortable seating and modern interiors suitable for city rides and long journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, railway stations, and airport terminals. Ideal for family vacations, sightseeing tours, and weekend trips. Large luggage space ensures convenient travel with bags. Flexible booking options allow easy ride reservations."
},
{
name: "Kia Carens Corporate Cab Mumbai",
description: "Kia Carens corporate cab in Mumbai provides reliable transportation for business executives and company employees. The vehicle offers comfortable seating and professional travel suitable for corporate rides and meetings. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from offices, hotels, airports, and business districts. Ideal for corporate events, airport transfers, and executive travel. Spacious interiors ensure comfortable journeys for professionals. Flexible booking options allow scheduled corporate trips."
},
{
name: "Kia Carens Booking Mumbai",
description: "Kia Carens booking in Mumbai allows passengers to easily reserve comfortable MPV transportation for city and outstation travel. Online and phone booking options provide quick ride confirmation and convenient scheduling. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for family travel, corporate trips, and tourism visits. Spacious interiors ensure comfortable journeys for passengers. Flexible booking options allow easy reservations anytime."
},
{
name: "Kia Carens Taxi Booking Mumbai",
description: "Kia Carens taxi booking in Mumbai provides convenient ride reservations for passengers looking for modern MPV transportation. The vehicle offers spacious seating and smooth travel suitable for city rides and long journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business trips, family travel, and airport transfers. Air-conditioned interiors ensure relaxed journeys for passengers. Flexible booking options allow quick taxi reservations."
},
{
name: "Kia Carens Per Km Rate Mumbai",
description: "Kia Carens per km rate in Mumbai provides transparent pricing for passengers traveling in comfortable Kia Carens MPV vehicles. The vehicle offers spacious seating and smooth highway travel for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for outstation trips, corporate travel, and family tours. Comfortable interiors ensure relaxing journeys for passengers. Clear pricing structure ensures affordable and transparent fares."
},
{
name: "Kia Carens Rental Near Me Mumbai",
description: "Kia Carens rental near me in Mumbai helps passengers quickly find nearby MPV rental services for comfortable travel. The vehicle provides spacious seating and smooth ride quality suitable for city and outstation trips. Professional drivers ensure punctual pickup and safe driving services across nearby locations. Pickup services are available from homes, offices, hotels, and transport hubs. Ideal for family travel, corporate trips, and airport transfers. Comfortable interiors ensure relaxed journeys for passengers. Flexible booking options allow quick ride confirmation."
},
{
name: "Kia Carens Luxury Cab Mumbai",
description: "Kia Carens luxury cab in Mumbai offers premium travel experience with stylish interiors and spacious seating. The vehicle provides smooth driving performance and comfortable ride quality for long journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, and airport terminals. Ideal for VIP travel, corporate executives, and luxury family trips. Air-conditioned interiors ensure relaxing journeys. Flexible booking options allow quick ride reservations."
},
{
name: "Kia Carens 6 Seater Cab Mumbai",
description: "Kia Carens 6 seater cab in Mumbai provides spacious transportation for small groups and families traveling together. The vehicle offers comfortable seating and modern interiors suitable for city travel and long journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family outings, corporate rides, and airport transfers. Spacious interiors ensure comfortable journeys for passengers. Flexible booking options allow easy reservations anytime."
}
],

tableData: [
["Kia Carens Cab Service Mumbai","Kia Carens on Rent Mumbai"],
["Kia Carens Taxi Mumbai","Kia Carens Rental Mumbai"],
["Kia Carens Airport Cab Mumbai","Kia Carens Outstation Cab Mumbai"],
["Kia Carens One Way Cab Mumbai","Kia Carens Family Cab Mumbai"],
["Kia Carens Corporate Cab Mumbai","Kia Carens Booking Mumbai"],
["Kia Carens Taxi Booking Mumbai","Kia Carens Per Km Rate Mumbai"],
["Kia Carens Rental Near Me Mumbai","Kia Carens Luxury Cab Mumbai"],
["Kia Carens 6 Seater Cab Mumbai","Kia Carens Hire Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Comfortable Kia Carens MPV for Travel",
    WhyChoosedescription: "Kia Carens is a modern and spacious MPV perfect for comfortable travel in Mumbai. With stylish interiors, smooth suspension, and ample seating space, it is ideal for family trips, airport transfers, and business travel."
  },
  {
    WhyChooseheading: "Affordable Kia Carens Rental Pricing",
    WhyChoosedescription: "Omshree Cabs offers competitive and transparent pricing for Kia Carens cab services in Mumbai. Customers are informed about per-kilometer rates, toll charges, and travel packages before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Kia Carens Cab Availability",
    WhyChoosedescription: "Our Kia Carens cab service in Mumbai is available 24 hours a day. Whether you need a late-night airport pickup or an early morning departure, Omshree Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All Kia Carens vehicles in our fleet are regularly serviced, cleaned, and sanitized to ensure a comfortable and safe travel experience for passengers."
  },
  {
    WhyChooseheading: "Perfect for Local & Outstation Trips",
    WhyChoosedescription: "Kia Carens is suitable for both local travel in Mumbai and long-distance journeys to destinations like Pune, Lonavala, Nashik, Shirdi, Mahabaleshwar, and Surat."
  },
  {
    WhyChooseheading: "Professional Chauffeur Drivers",
    WhyChoosedescription: "Our trained drivers are experienced in navigating Mumbai roads and highways. They ensure safe driving and a smooth travel experience for passengers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports across Mumbai so passengers can start their journey without any hassle."
  },
  {
    WhyChooseheading: "Trusted Kia Carens Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Kia Carens cab services in Mumbai because of our punctual service, comfortable vehicles, and professional drivers."
  }
]
};

const faqData = [
  { question: "Do you provide Kia Carens cab service in Mumbai?", answer: "Yes, Omshree Cabs provides Kia Carens cab services in Mumbai for local travel, airport transfers, and outstation trips." },
  { question: "What is the seating capacity of Kia Carens?", answer: "Kia Carens is a 6 to 7 seater MPV suitable for families, business travelers, and small groups." },
  { question: "Can I book Kia Carens for Mumbai Airport transfer?", answer: "Yes, Kia Carens is commonly used for Mumbai Airport pickup and drop services due to its spacious seating and luggage capacity." },
  { question: "Is Kia Carens suitable for long-distance travel?", answer: "Yes, Kia Carens offers excellent comfort and is ideal for long-distance journeys from Mumbai." },
  { question: "Do you provide Kia Carens for outstation trips?", answer: "Yes, we provide Kia Carens rentals from Mumbai to destinations like Pune, Lonavala, Nashik, Shirdi, Surat, and other cities." },
  { question: "Are Kia Carens vehicles air-conditioned?", answer: "Yes, all Kia Carens vehicles provided by Omshree Cabs are fully air-conditioned." },
  { question: "Do you provide drivers with the vehicle?", answer: "Yes, all Kia Carens rentals include professional and experienced drivers." },
  { question: "Can I book Kia Carens for full-day travel?", answer: "Yes, we offer full-day and multi-day Kia Carens rental packages in Mumbai." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and peak travel seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Mehta",
    feedback:
      "We booked a Kia Carens cab from Omshree Cabs for our Mumbai to Lonavala trip. The car was spacious and very comfortable for our family.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback:
      "Excellent Kia Carens cab service in Mumbai. Clean vehicle, polite driver, and smooth travel experience.",
    rating: 5
  }
];


















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kia Carens Cab Service in Mumbai",
  "description": "Omshree Cab provides Kia Carens on rent in Mumbai for local travel, airport transfers, outstation trips, one-way journeys, and round trips. Available as a 6-seater, our Kia Carens cabs are ideal for families, corporate travel, and luxury trips. Enjoy well-maintained vehicles, transparent per km rates, and easy online booking for a safe and comfortable ride across Mumbai.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "900"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Kia Carens Cab Service in Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab offers Kia Carens on rent in Mumbai for local travel, airport, outstation, one-way, and round trips. 6-seater family and corporate cab with luxury options, transparent per km rates, and well-maintained vehicles." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/53.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kiacarencecabserviceinmumbai;